// extracted by mini-css-extract-plugin
export default {"description":"Q82V4j"};